import { snakeCase } from 'lodash';
import React, { useEffect } from 'react';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { tableCase } from '@sierralabs/core';
import { useFindEntityData } from '../hooks/useFindEntityData';
export function isRelationColumn(entity, column) {
    return Boolean(findCreateFieldRelation(entity, column));
}
export function findCreateFieldRelation(entity, column) {
    var _a;
    return (_a = entity.relations) === null || _a === void 0 ? void 0 : _a.find(relation => {
        const name = column.columnName || snakeCase(column.displayName);
        return (typeof relation.joinColumn === 'object' &&
            relation.joinColumn.name === name);
    });
}
export const EntityRelationField = ({ plugin, entity, column, value, label, placeholder, helperText, error, onChange }) => {
    var _a, _b, _c;
    const validationError = (_b = (_a = plugin.edit) === null || _a === void 0 ? void 0 : _a.validateError) === null || _b === void 0 ? void 0 : _b.call(_a, column, value);
    const target = ((_c = findCreateFieldRelation(entity, column)) === null || _c === void 0 ? void 0 : _c.target) || '';
    const { entityData, getEntityData } = useFindEntityData(tableCase(target));
    const options = entityData === null || entityData === void 0 ? void 0 : entityData.data.map(item => item.id);
    // fetch entity data
    // TODO: handle pagination
    useEffect(() => getEntityData(), [getEntityData, target]);
    return (React.createElement(Autocomplete, { forcePopupIcon: true, fullWidth: true, 
        // disabled={disabled}
        disableClearable: true, options: options || [], value: value || undefined, getOptionLabel: option => option.toString(), onChange: (_, value) => {
            onChange === null || onChange === void 0 ? void 0 : onChange(value);
        }, renderInput: params => (React.createElement(TextField, Object.assign({ className: 'entity-field' }, params, { fullWidth: true, size: 'small', label: label, placeholder: placeholder || `Select a ${target}`, error: Boolean(error) || Boolean(validationError), helperText: validationError || helperText, variant: 'outlined' }))) }));
};
//# sourceMappingURL=EntityRelationField.js.map